/**
 * Prompt Sprint Lesson
 * Skill Area: Communication
 * Master prompt precision with the ATGTI formula
 */

import type { LessonDefinition } from '../types';
import { PROMPT_SPRINT_AI_PROMPT, PROMPT_SPRINT_CONTEXT_SCENARIOS } from '../prompts/prompt-sprint.prompt';

export const promptSprint: LessonDefinition = {
  id: 'prompt-sprint',
  title: 'Prompt Sprint',
  displayTitle: 'Craft Precise Prompts with the ATGTI Formula',
  subTitle: 'Turn a rough prompt into ready copy.',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Beginner',
  estimatedMinutes: 7,
  tags: ['prompts', 'copy', 'iteration'],
  dailyEligible: true,
  releasedAt: '2025-01-20T00:00:00.000Z',
  route: '/micro/prompt-sprint',
  storyBeat: 'Trim the noise so AI knows exactly what you need.',
  contextTitle: "Use this prompt fuel",
  contextSummary: "Pick the situation closest to yours so Lyra can tighten it fast.",
  contextScenarios: PROMPT_SPRINT_CONTEXT_SCENARIOS,
  introPrompt: "Vague prompts produce vague outputs. I'll explain why precision matters, show you a comparison, and then we'll sharpen your own prompt.",
  steps: [
    "Select a writing task (e.g., Donor Email)",
    'See a "Lazy vs. Sharpened" comparison',
    'Brief Lyra to rewrite your draft'
  ],
  promptGuidance: 'Choose a task below or type your own.',
  aiPrompt: PROMPT_SPRINT_AI_PROMPT,
  inputPlaceholder: "Type 'Donor Email' or your own task...",
  quickPrompts: [
    'Donor Email',
    'Social Caption',
    'Report Summary'
  ]
};
